import { baseService } from "service/base";

class DeviceResourcesService {
  load(deviceId, type = "all", hours = 1) {
    return baseService.get(
      `/api/device/resources/${deviceId}?type=${type}&hours=${hours}`,
    );
  }
}

const deviceResourcesService = new DeviceResourcesService();

export { deviceResourcesService };
